import { useIntersectionObserver } from 'helpers/useIntersectionObserver'
import React, { FC, useCallback, useRef } from 'react'
import styled from 'styled-components'

const StyledVideo = styled.video`
  object-fit: cover;
  object-position: center;
`

interface Props {
  src: string
  previewSrc?: string
}

const VideoTile: FC<Props> = ({ src, previewSrc }) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const onVisibilityChange = useCallback(
    async (domNode: HTMLVideoElement | null, intersecting: boolean) => {
      if (domNode) {
        if (intersecting) {
          try {
            // play is async and can fail when it's paused before play is done
            // in this case we don't care about too early pauses
            await domNode.play()
          } catch (e) {}
        } else {
          domNode.pause()
        }
      }
    },
    [],
  )
  useIntersectionObserver(videoRef, onVisibilityChange, 0)

  return <StyledVideo ref={videoRef} loop muted poster={previewSrc} src={src} />
}

export default VideoTile
